
import React from 'react';

const AdvisoryBox = ({ title, desc, fee }: { title: string, desc: string, fee: string }) => (
  <div className="p-10 bg-white border border-slate-200 rounded-none flex flex-col h-full">
    <h3 className="text-xl font-black text-slate-900 mb-6 uppercase tracking-tighter">{title}</h3>
    <p className="text-sm text-slate-500 leading-relaxed font-medium mb-10 flex-grow">{desc}</p>
    <div className="pt-6 border-t border-slate-100 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
      Fee Structure: <span className="text-slate-900">{fee}</span>
    </div>
  </div>
);

const Advisory: React.FC = () => {
  return (
    <div className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mb-24">
          <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400 mb-8">Commercial & Professional Services</div>
          <h1 className="text-6xl font-black text-slate-900 mb-8 tracking-tighter">The Zero-Failure Framework:<br/><span className="text-slate-400">Institutional Risk Mitigation</span></h1>
          <p className="text-xl text-slate-600 leading-relaxed font-medium">
            Specialized advisory services designed to identify "Institutional Entropy" and failure points before they manifest as catastrophic legal or financial liabilities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-24">
          <AdvisoryBox 
            title="Forensic Structural Audit (FSA)"
            desc="Deep-tier analysis of organizational 'soft tissue'—governance models, personnel incentives, and decision-making hierarchies—to identify vulnerabilities to Agency Capture."
            fee="Tiered Project Fee — Available upon application."
          />
          <AdvisoryBox 
            title="AI Integrity & Alignment Consulting"
            desc="Rigorous testing of AI outputs to detect 'hidden weighting' and ensure systems are accurate, unbiased, and legally defensible."
            fee="Custom Engagement — Available upon inquiry."
          />
          <AdvisoryBox 
            title="Regulatory Integrity Mapping (RIM)"
            desc="A forensic map of the 'Regulatory Drift' between national mandates and international treaties to safeguard against bureaucratic overreach."
            fee="Retainer or Project-Based — Available upon application."
          />
          <AdvisoryBox 
            title="Public Forum Facilitation & Defense"
            desc="A high-security professional environment for institutions to defend their data and policies against public inquiry in a structured, evidence-led format."
            fee="Fixed Event Fee — Available upon application."
          />
        </div>

        <div className="p-12 bg-black text-white text-center">
            <h2 className="text-2xl font-black uppercase tracking-tighter mb-6">Institutional Integrity Inquiry</h2>
            <p className="text-slate-400 max-w-2xl mx-auto mb-10">If your institution is experiencing internal entropy or requires a forensic review of its alignment with public interest mandates, contact our advisory wing.</p>
            <a href="mailto:advisory@systemaudit.org" className="inline-block px-10 py-5 bg-white text-black font-bold uppercase tracking-widest hover:bg-slate-200 transition-all text-sm">
                Request Private Consultation
            </a>
        </div>
      </div>
    </div>
  );
};

export default Advisory;
